import { Toast, ToastBody, ToastTitle, useToastController } from "@fluentui/react-components";
import React, { useCallback } from "react";

export type ToastIntent = "success" | "error" | "warning" | "info";

export interface ShowToastOptions {
  title: string;
  message: string;
  intent: ToastIntent;
  timeout?: number;
}

export const useToast = (toasterId: string) => {
  const { dispatchToast } = useToastController(toasterId);

  const showToast = useCallback(
    ({ title, message, intent, timeout }: ShowToastOptions) => {
      dispatchToast(
        <Toast>
          <ToastTitle>{title}</ToastTitle>
          <ToastBody>{message}</ToastBody>
        </Toast>,
        { intent, timeout }
      );
    },
    [dispatchToast]
  );

  return {
    showToast,
  };
};
